import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation, components as Core } from '../../../core';
import { common, css, paddings, marginsRight } from '../../../../styles';

export const UnlinkComrcePopover = ({ onPress, isLoading }) => {
    const { t } = useTranslation();
    const [isVisiblePopup, setIsVisiblePopup] = useState(false);

    const togglePopover = () => setIsVisiblePopup(prev => !prev);

    const handleConfirm = () => {
        onPress();
        setIsVisiblePopup(false);
    };

    const handleCancel = () => {
        setIsVisiblePopup(false);
    };

    const getPopoverContent = () => (
        <div className={css([common.flexColumn, paddings.s3])}>
            <div className={marginsRight.s2}>{t('delete.title')}</div>
            <div className={css([common.flexRowEnd, paddings.s3])}>
                <Core.Button
                    onPress={handleConfirm}
                    label={t('delete.yes')}
                    className={marginsRight.s2}
                />
                <Core.Button
                    onPress={handleCancel}
                    label={t('delete.no')}
                />
            </div>
        </div>
    );

    return (
        <Core.Popover
            content={getPopoverContent()}
            visible={isVisiblePopup}
            onVisibleChange={setIsVisiblePopup}>
            <>
                <Core.Button
                    label="Unlink Comrce Account"
                    onPress={togglePopover}
                    isLoading={isLoading}
                    type="danger"
                />
            </>
        </Core.Popover>
    );
};

UnlinkComrcePopover.propTypes = {
    onPress: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
};

UnlinkComrcePopover.defaultProps = {
    isLoading: false
};
